ats.makeTextEditor = function (element, onUpdateCallback = null) {
    if ($(element).length > 0) {
        ats._pendingEditorContent = ats._pendingEditorContent || {};

        function initEditor() {
            var isDark = document.body.classList.contains('dark-mode');

            tinymce.init({
                selector: element,
                skin: isDark ? 'oxide-dark' : 'oxide',
                content_css: isDark ? 'dark' : 'default',
                license_key: 'gpl',
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'table', 'help', 'wordcount'
                ],
                toolbar: 'blocks fontsize | bold italic forecolor backcolor | link | indent outdent | bullist numlist blockquote | table | removeformat',
                menubar: false,
                height: 400,
                promotion: false,
                // contextmenu: false disables TinyMCE's right-click menu so the browser's native menu (with spelling suggestions) is shown
                // contextmenu: 'cut copy paste pastetext selectall | link | table',
                contextmenu: false,
                browser_spellcheck: true,
                paste_merge_formats: true,
                //paste_retain_style_properties: 'all',
                //paste_word_valid_elements: '-strong/b,-em/i,-u,-span[style|class],-p[style],-ol[style|start],-ul[style],-li[style],-h1,-h2,-h3,-h4,-h5,-h6,-p/div,-a[href|name|target],sub,sup,strike,br,del,table[width|style],tr,td[colspan|rowspan|width|style],th[colspan|rowspan|width|style],thead,tfoot,tbody',
                // Strip font-family / font-size / line-height from pasted content so text
                // copied from another editor inherits the destination's typography instead
                // of carrying inline styles across (which also causes layout jitter on paste).
                paste_postprocess: function (plugin, args) {
                    args.node.querySelectorAll('[style]').forEach(function (el) {
                        el.style.removeProperty('font-family');
                        el.style.removeProperty('font-size');
                        el.style.removeProperty('line-height');
                        if (!el.style.length) {
                            el.removeAttribute('style');
                        }
                    });
                },
                base_url: '/components/tinymce/js',
                setup: function (editor) {
                    text_editor = editor;
                    ats.textEditors = ats.textEditors || {};
                    ats.textEditors[element] = editor;

                    editor.on('init', function () {
                        if (ats._pendingEditorContent[element]) {
                            editor.setContent(ats._pendingEditorContent[element]);
                            delete ats._pendingEditorContent[element];
                        }
                    });

                    editor.on('keydown', function () {
                        ats.emailIsEdited = true;
                    });

                    editor.on('change keyup', function () {
                        const content = editor.getContent();
                        document.querySelector(element).value = content;
                        if (typeof onUpdateCallback === 'function') {
                            onUpdateCallback(content);
                        }
                    });
                }
            });

            // Reinitialise with correct skin when dark mode is toggled
            document.addEventListener('dark_mode_changed', function () {
                ats._pendingEditorContent[element] = ats.textEditors && ats.textEditors[element] ? ats.textEditors[element].getContent() : '';
                tinymce.remove(element);
                ats.makeTextEditor(element, onUpdateCallback);
            }, { once: true });
        }

        // Defer until DOMContentLoaded so the dark-mode class is applied before we check it
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initEditor);
        } else {
            initEditor();
        }
    } else {
        console.log(`Cannot create text editor: ${element} does not exist.`);
    }
}
